import React from "react";
import { getRoundedInrFormatWithSymbol } from "../../../utilities";
import AmcDetailCard from "./AmcDetailCard";

const AboutAmc = ({ amc }) => (
  <div className="w-100 flex-col para-3 amcDetailContainer">
    <div className="flex spacer_md align-center" style={{ marginTop: "8px" }}>
      <img
        src={`https://assets.piggy.co.in/amc/icons/${amc.display_name_id}_piggy.svg`}
        alt="Amc logo"
        style={{ width: "50px", height: "50px" }}
      />
      <div className="flex-col justify-center amcNameContainer">
        <h1 className="heading-1-bold">{amc.display_name}</h1>
        <div className="d-f a-i-c">
          <span className="para-3 ">AUM</span>
          <span className="para-3-bold aumValue">
            {getRoundedInrFormatWithSymbol(amc.aum)} Cr
          </span>
        </div>
      </div>
    </div>
    <div className="heading-3-bold spacer_sm">About</div>
    <p className="para-2 aboutDetails">{amc.about}</p>
    <div className="flex-col space-between">
      <div className="aboutAmcDetailCard">
        <AmcDetailCard amc={amc} where="ABOUT_AMC" />
      </div>
    </div>
    <style jsx>
      {`.amcDetailContainer{
          margin-bottom: 24px;
          box-sizing: border-box;
          padding-bottom: 32px;
      }
      @media (max-width: 768px) {
        .amcDetailContainer {
          padding-bottom: 0;
        }
      } 
        .amcNameContainer{
          margin-left:16px;
        }
        .aumValue{
          margin-left:8px;
        }
        .aboutAmcDetailCard{
          dispay:none;
        }
        @media screen and (max-width:768px){
          .aboutAmcDetailCard{
            display:inherit;
          }
        }
      `}
    </style>
  </div>
);

export default AboutAmc;
